import {JsonServiceClient} from '@servicestack/client';
import {event} from "vue-gtag";

declare var global: any; // populated from package.json/karma/globals
export let client = new JsonServiceClient(global.BaseUrl || '/api').useBasePath();
export const trackEvent = (evt: string, params: {}, sendToCustomerIo: boolean = true, sendToGa: boolean = true) => {
    if(sendToCustomerIo){
        // @ts-ignore
        window.analytics.track(evt, params);
    }
    
    if(sendToGa){
        event(evt, params);
    }
    
};

export const UploadCareSettings = {
    maxLocalFileSizeBytes : 1024 * 1024 * 4,
    sourceList: "local, url, camera, dropbox, facebook, instagram"
}

export const maxHeadshotSizeAllowed = 1024 * 1024 * 4; // 4 MB

export const validateFileSize = (max: any) => {
    return function (fileInfo: any) {
        if (fileInfo.size === null) {
            return;
        }
        if (max && fileInfo.size > max) {
            throw new Error("fileMaximumSize");
        }
    };
};

export const validateFileType = (types: any) => {
    types = types.split(' ');
    return function (fileInfo: any) {
        if (fileInfo.name === null) {
            return;
        }
        let extension = fileInfo.name.split('.').pop();
        if (types.indexOf(extension) === -1) {
            throw new Error("fileType");
        }
    };
};
export const fileValidators = [
    validateFileSize(maxHeadshotSizeAllowed) // limit file size to 4 MB
];